module.exports = __webpack_public_path__ + "static/IMC_logo_blue_FR-6c5eddb778a219b4db86d3ef46a52473.svg";